<div class="mt-3" id="box-negotiation-template">
    <hot-table *ngIf="show" hotId="negotiation-template" [settings]="modifiedTableSettings"></hot-table>
</div>